import React from 'react';
import { AcaoConfirmarPdf, IAuditFile } from '../interfaces/IAuditoriaEntradaDados';
import AuditFileItem from './AuditFileItem';

interface Props {
  arquivos: IAuditFile[];
  carregando: boolean;
  onAdicionarDados: () => void;
  onVerHistorico: (arquivo: IAuditFile) => void;
  onSubstituir: (arquivo: IAuditFile) => void;
  onReprocessar: (arquivo: IAuditFile) => void;
  onExcluir: (arquivo: IAuditFile) => void;
  onVerResultado?: (arquivo: IAuditFile) => void;
  onDecidirPdf?: (arquivo: IAuditFile, processar: boolean) => void;
  onConfirmarPdf?: (arquivo: IAuditFile, acao: AcaoConfirmarPdf) => void;
  idsReprocessando: Set<number>;
  idsOcupados?: Set<number>;
}

// Épico "Central de Entrada de Dados", seção 42 (listagem) e seção 44 do segundo Épico (estado
// vazio) — tabela de arquivos importados para a Empresa/Conta/Período selecionados.
const AuditFileList: React.FC<Props> = ({
  arquivos,
  carregando,
  onAdicionarDados,
  onVerHistorico,
  onSubstituir,
  onReprocessar,
  onExcluir,
  onVerResultado,
  onDecidirPdf,
  onConfirmarPdf,
  idsReprocessando,
  idsOcupados,
}) => {
  if (carregando) {
    return <div className='text-muted text-center py-5'>Carregando arquivos...</div>;
  }

  if (arquivos.length === 0) {
    return (
      <div className='audit-empty-state'>
        <i className='bi bi-inbox audit-empty-state-icon' />
        <div className='audit-empty-state-title'>Nenhum arquivo importado</div>
        <div className='audit-empty-state-texto'>Adicione um novo arquivo para continuar com a auditoria.</div>
        <button type='button' className='btn btn-sm btn-primary mt-3' onClick={onAdicionarDados}>
          Adicionar Dados
        </button>
      </div>
    );
  }

  return (
    <div className='table-responsive'>
      <table className='table table-sm table-row-dashed table-row-gray-200 align-middle gs-0 gy-2 fs-8'>
        <thead>
          <tr className='fw-bolder text-muted'>
            <th>Arquivo</th>
            <th>Formato</th>
            <th>Conta Contábil</th>
            <th>Período</th>
            <th>Tamanho</th>
            <th>Upload</th>
            <th className='text-center'>Status</th>
            <th className='text-center'>Validação</th>
            <th>Processamento</th>
            <th className='text-end'>Ações</th>
          </tr>
        </thead>
        <tbody>
          {arquivos.map((arquivo) => (
            <AuditFileItem
              key={arquivo.id}
              arquivo={arquivo}
              onVerHistorico={onVerHistorico}
              onAdicionarNovo={onAdicionarDados}
              onSubstituir={onSubstituir}
              onReprocessar={onReprocessar}
              onExcluir={onExcluir}
              onVerResultado={onVerResultado}
              onDecidirPdf={onDecidirPdf}
              onConfirmarPdf={onConfirmarPdf}
              reprocessando={idsReprocessando.has(arquivo.id)}
              ocupado={idsOcupados?.has(arquivo.id)}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AuditFileList;
